document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll(".js-accordion-wrapper");

  if (accordions) {
    accordions.forEach((accordion) => {
      const headers = accordion.querySelectorAll(".js-accordion-header");

      headers.forEach((header) => {
        header.addEventListener("click", () => {
          const parentEl = header.parentElement;

          // Check if there's an open accordion and it's not the one just clicked
          const openAccordion = accordion.querySelector(
            ".js-accordion-item.active"
          );
          if (openAccordion && openAccordion !== parentEl) {
            openAccordion.classList.remove("active");
          }

          // Toggle the clicked accordion
          parentEl.classList.toggle("active");
          console.log(parentEl);
        });
      });
    });
  }
});
